import { useState } from "react"
import ActionMenu, {
  type ActionMenuItemProps,
} from "@/v2-backoffice-client/components/actionMenu"
import LicensePlanDeprecateDialog from "@/v2-backoffice-client/license/plan/deprecate/LicensePlanDeprecateDialog"
import type { LicensePlanFragment } from "@/v2-backoffice-client/license/plan/__types__/license.plan.fragment"

export type LicensePlanDeprecateMenuItemProps = Omit<
  ActionMenuItemProps,
  "onClick"
> & {
  plan: LicensePlanFragment
}

// The board row menu's entry to the deprecation dialog (the license panel's
// toolbar opens the same dialog via a direct button). Red while it would
// deprecate; once the license is deprecated the same item edits or lifts the
// deprecation, which is not a dangerous act.
function LicensePlanDeprecateMenuItem(
  props: LicensePlanDeprecateMenuItemProps,
) {
  const { plan, children, ...menuItemProps } = props
  const [isOpen, setIsOpen] = useState(false)
  const isDeprecated = Boolean(plan.DeprecatedAt)

  return (
    <>
      <ActionMenu.Item
        iconSrc="archive"
        variant={isDeprecated ? undefined : "destructive"}
        data-feature-code="UI_BackofficeLicensePlan_Row_Deprecation"
        onSelect={(e) => {
          e.preventDefault()
          setIsOpen(true)
        }}
        {...menuItemProps}
      >
        {children ?? (isDeprecated ? "Edit Deprecation" : "Deprecate License")}
      </ActionMenu.Item>

      {/* Mounted per open so the fields re-seed from the plan every time. */}
      {isOpen && (
        <LicensePlanDeprecateDialog
          plan={plan}
          open={isOpen}
          onOpenChange={setIsOpen}
        />
      )}
    </>
  )
}

export default LicensePlanDeprecateMenuItem
